import classNames from 'classnames'
import { formatPercentage } from '../../utils'
import styles from '../styles.module.scss'

const SurveyDetails = ({ surveyResults }) => (
    <div className={classNames('row justify-content-center text-center', styles.surveyDetails)}>
        <div className="col">
            <h2>
                <T>nps.admin.dashboard.total.responses</T>
            </h2>
            <h2 className={styles.detailsNumberValues}>{surveyResults?.answersCount}</h2>
        </div>
        <div className="col">
            <h2>
                <T>nps.admin.dashboard.response.rate</T>
            </h2>
            <h2 className={styles.detailsNumberValues}>{formatPercentage(surveyResults?.answersPercentage)}%</h2>
        </div>
        <div className="col">
            <h2>
                <T>nps.admin.dashboard.average.rating</T>
            </h2>
            <h2 className={styles.detailsNumberValues}>{formatPercentage(surveyResults?.averageRating)}</h2>
        </div>
        <div className="col">
            <h2>
                <T>nps.admin.dashboard.nps.score</T>
            </h2>
            <h2 className={styles.detailsNumberValues}>{formatPercentage(surveyResults?.npsScore)}</h2>
        </div>
    </div>
)

export default SurveyDetails
